import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Typography, Stack, RadioGroup, FormControlLabel, Radio } from '@mui/material';

export default function YesNoOptions({ data, updateOptions }) {
  const { t } = useTranslation(['procedures']);
  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        {t('procedures:step_options.yes_no_options')}
      </Typography>
      <Stack spacing={2}>
        {/* Text inputs side by side */}
        <Box display="flex" gap={2}>
          <TextField
            fullWidth
            label={t('procedures:form_labels.yes_no.yes_label')}
            value={data.options?.yes_label || ''}
            onChange={(e) => updateOptions({ yes_label: e.target.value })}
          />
          <TextField
            fullWidth
            label={t('procedures:form_labels.yes_no.no_label')}
            value={data.options?.no_label || ''}
            onChange={(e) => updateOptions({ no_label: e.target.value })}
          />
        </Box>

        {/* Radio buttons below */}
        <Box display="flex" gap={2}>
          <Box flex={1}>
            <RadioGroup
              value={data.options?.default_value || 'yes'}
              onChange={(e) => updateOptions({ default_value: e.target.value })}
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label={t('procedures:form_labels.yes_no.default_value')}
              />
            </RadioGroup>
          </Box>
          <Box flex={1}>
            <RadioGroup
              value={data.options?.default_value || 'yes'}
              onChange={(e) => updateOptions({ default_value: e.target.value })}
            >
              <FormControlLabel
                value="no"
                control={<Radio />}
                label={t('procedures:form_labels.yes_no.default_value')}
              />
            </RadioGroup>
          </Box>
        </Box>
      </Stack>
    </>
  );
}
